<template>
  <ValidationObserver ref="editInterviewParticipantDialog">
    <BaseDialog :isOpen="isOpen">
      <template v-slot:title>
        {{ title }}
      </template>
      <template v-slot:body>
        <ValidationProvider
          v-if="!hideTextarea"
          v-slot="{ errors }"
          name="reason"
          :rules="{ required: !isConfirmInterview }"
        >
          {{ label }}
          <v-textarea
            :error-messages="showValidationErrors ? errors : ''"
            v-model="reason"
            height="180"
            color="primary"
            :placeholder="placeholder"
            class="mt-0"
          />
        </ValidationProvider>
      </template>
      <template v-slot:actions>
        <div>
          <PrimaryButton @click.native="close" text>
            Cancel
          </PrimaryButton>
          <ErrorButton
            @click.native="handleClick"
            :loading="isLoading"
            v-if="buttonType === 'error'"
          >
            {{ buttonText }}
          </ErrorButton>
          <PrimaryButton
            @click.native="handleClick"
            :loading="isLoading"
            v-else
          >
            {{ buttonText }}
          </PrimaryButton>
        </div>
      </template>
    </BaseDialog>
  </ValidationObserver>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { copyState } from "@/utils/helpers";
import ErrorButton from "@/components/common/Button/ErrorButton";
import { INTERVIEWS_NAMESPACE } from "@/store/modules/bookings/interviews";
import { EDIT_INTERVIEW_PARTICIPANT } from "@/store/modules/bookings/interviews/actions";
import { createNamespacedHelpers } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { getCurrentParticipantId } from "@/views/bookings/BookingInterviews/modules/utils";

const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

const {
  mapActions: mapInterviewActions,
  mapState: mapInterviewState
} = createNamespacedHelpers(INTERVIEWS_NAMESPACE);

export default {
  name: "EditInterviewParticipantStatusDialog",
  components: {
    ErrorButton,
    PrimaryButton,
    BaseDialog,
    ValidationObserver,
    ValidationProvider
  },
  props: {
    isOpen: Boolean,
    title: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    status: {
      type: String
    },
    buttonType: String,
    label: String,
    hideTextarea: Boolean
  },
  data() {
    return {
      isLoading: false,
      showValidationErrors: false,
      reason: ""
    };
  },
  computed: {
    ...mapAuthState({
      userData: state => state.userData
    }),
    ...mapInterviewState(copyState(["currentInterviewSlot"])),
    currentInterviewId() {
      return this.$route.params.interviewId;
    },
    isConfirmInterview() {
      return this.status === "accepted";
    },
    placeholder() {
      return this.isConfirmInterview ? "E.g BSL interpretor" : "Add comment...";
    },
    editedInterviewParticipantData() {
      const data = {
        ...(this.status && { participantRsvpStatus: this.status }),
        ...(this.reason && { reason: this.reason })
      };
      if (this.isConfirmInterview && this.reason) {
        data.adjustmentRequested = this.reason;
      }

      return data;
    }
  },
  methods: {
    ...mapInterviewActions({
      editInterviewParticipant: EDIT_INTERVIEW_PARTICIPANT
    }),
    async handleClick() {
      this.showValidationErrors = true;
      const isFormValid = await this.$refs.editInterviewParticipantDialog.validate();
      if (isFormValid) {
        this.isLoading = true;
        const participantId = getCurrentParticipantId({
          userId: this.userData.id,
          participants: this.currentInterviewSlot.participants
        });
        await this.editInterviewParticipant({
          interviewId: this.currentInterviewId,
          participantId,
          data: this.editedInterviewParticipantData,
          refreshInterviewSlot: true
        });
        this.isLoading = false;
        this.close();
      }
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
